import React, { useEffect, useState } from "react";
import { Form, Input, Button, Typography, Row, Col, message, Spin } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../../pageHeader/LeftLayout";
import { COMMON_ERROR_MSG } from "../../../constants/constants";
import { routes } from "../../../routes/Routes";
import IntegerInput from "../../../components/IntergerInput";
import _capitalProviderService from "../../../modules/capitalProviderService";

const { Title } = Typography;

const CapitalProviderProfessionalDetails = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const capitalProviderUserId = localStorage.getItem("capitalProviderUserId");
    const [proffesionalDetails, setProffesionalInfoDetails] = useState({});
    const [form] = Form.useForm();
    const location = useLocation();
    let data = location.state;
    let capitalProviderIdFromProfile = "";
    let fromDashboard = false;

    if (data && data.capitalProviderUserId) {
        capitalProviderIdFromProfile = data.capitalProviderUserId;
    }

    if (data && data.isFromDashboard) {
        fromDashboard = data.isFromDashboard;
    }
    const [capitalProviderFromProfileID] = useState(capitalProviderIdFromProfile);
    const [isFromDashboard] = useState(fromDashboard);

    useEffect(() => {
        getLoanOfficerInformationByLoanOfficerId();
    }, [])

    useEffect(() => form.resetFields(), [proffesionalDetails]);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const reqObj = {
                Id: capitalProviderFromProfileID ? Number(capitalProviderFromProfileID) : Number(capitalProviderUserId),
                ScreenName: "proffesionaldetails",
                JobRole: values.jobRole,
                InstitutionName: values.institutionName,
                OfficeAddress: values.officeAddress,
                City: values.city,
                State: values.state,
                ZipCode: values.zipCode,
                IdentificationNumber: values.idNumber,
            }
            const res = await _capitalProviderService.updateLoanOfficerData(reqObj);
            if (res.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message)
                if (isFromDashboard) {
                    history.push({ pathname: routes.capitalProviderProfile.path, state: { capitalProviderUserId, } });
                } else {
                    history.push(routes.capitalProviderDashboard.path);
                }

            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const getLoanOfficerInformationByLoanOfficerId = async () => {
        setLoading(true);
        try {
            const resObj = await _capitalProviderService.getLoanOfficerInformationByLoanOfficerId(capitalProviderFromProfileID ? capitalProviderFromProfileID : capitalProviderUserId);
            if (resObj.data) {
                const res = resObj.data.Obj;
                setProffesionalInfoDetails({
                    jobRole: res.JobRole,
                    institutionName: res.InstitutionName,
                    officeAddress: res.OfficeAddress,
                    city: res.City,
                    state: res.State,
                    zipCode: res.ZipCode,
                    idNumber: res.IdentificationNumber,
                });
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    const onBack = () => {
        if (isFromDashboard) {
            history.push({ pathname: routes.capitalProviderProfile.path, state: { capitalProviderUserId, } });
        } else {
            history.push(routes.capitalProviderPersonalDetails.path);
        }
    }

    return (
        <Spin spinning={loading}>
            <LeftLayout>
                  <div className="profile-wrapper">
                    <div className="profile-card">
                    <Title level={3} style={{ fontWeight: "bold", color: "#d3d3d3"}}>
                        Capital Provider Portal
                    </Title>

                    <Title level={4} style={{ marginBottom: 24 }}>
                        Professional Details
                    </Title>

                    <Form form={form} layout="vertical" onFinish={onFinish} requiredMark={true}
                        initialValues={proffesionalDetails} >

                    <Row gutter={16} >
                        <Col xs={24} sm={24} md={12} lg={12} xl={12} >
                        <Form.Item
                            label="Job Role"
                            name="jobRole"
                            rules={[{ required: true, message: "Job Role is required" }]}
                        >
                            <Input size="large" placeholder="Enter Job Role" maxLength={30} />
                        </Form.Item>
</Col>
<Col xs={24} sm={24} md={12} lg={12} xl={12} >
                        <Form.Item
                            label="Institution Name"
                            name="institutionName"
                            rules={[{ required: false, message: "Institution Name is required" }]}
                        >
                            <Input disabled size="large" placeholder="Enter Institution Name" maxLength={100} />
                        </Form.Item>
</Col>
<Col xs={24} sm={24} md={24} lg={24} xl={24} >
                        <Form.Item
                            label="Office Address (Street Address, P.O Box)"
                            name="officeAddress"
                            rules={[{ required: false, message: "Office Address is required" }]}
                        >
                            <Input.TextArea
                                autoSize
                                disabled
                                size="large"
                                placeholder="Enter Office Address (Street Address, P.O Box)"
                                // rows={3}
                                maxLength={500}
                            />
                        </Form.Item>
</Col>
<Col xs={24} sm={24} md={12} lg={12} xl={12} >
                        <Form.Item
                            label="City"
                            name="city"
                            rules={[
                                {
                                    required: false,
                                    message: 'City is required',
                                },
                                {
                                    pattern: /^[A-Za-z\s]+$/,

                                },
                            ]}
                        >
                            <Input
                                size="large"
                                placeholder="Enter City"
                                maxLength={30}
                                onKeyPress={(e) => {
                                    const char = String.fromCharCode(e.which);
                                    if (!/^[A-Za-z\s]$/.test(char)) {
                                        e.preventDefault();
                                    }
                                }}
                                disabled
                            />
                        </Form.Item>
</Col>
<Col xs={24} sm={24} md={12} lg={12} xl={12} >
                        <Form.Item
                            label="State"
                            name="state"
                            rules={[
                                {
                                    required: false,
                                    message: 'State is required',
                                },
                                {
                                    pattern: /^[A-Za-z\s]+$/,

                                },
                            ]}
                        >
                            <Input
                                size="large"
                                placeholder="Enter State"
                                maxLength={30}
                                onKeyPress={(e) => {
                                    const char = String.fromCharCode(e.which);
                                    if (!/^[A-Za-z\s]$/.test(char)) {
                                        e.preventDefault();
                                    }
                                }}
                                disabled
                            />
                        </Form.Item>
</Col>
<Col xs={24} sm={24} md={12} lg={12} xl={12} >
                        <Form.Item
                            label="Zip Code"
                            name="zipCode"
                            rules={[
                                {
                                    required: false,
                                    message: 'Zip Code is required',
                                }
                            ]}
                        >
                            <IntegerInput disabled placeholder="Enter Zip Code" maxLength={10} />
                        </Form.Item>
</Col>
                        {/* <Form.Item
                            label="ID Number"
                            name="idNumber"
                            rules={[{ required: true, message: "Please enter ID number" }]}
                            className='w50'
                        >
                            <Input size="large" placeholder="Enter ID Number" maxLength={30} />
                        </Form.Item> */}

                        {/* <Form.Item
                        label="Photo Of ID"
                        name="photoOfId"
                        valuePropName="fileList"
                        getValueFromEvent={(e) => Array.isArray(e) ? e : e && e.fileList}
                        extra="Format: png, jpeg     Size: 155k-350k"
                    >
                        <Upload beforeUpload={beforeUpload} maxCount={1}>
                            <Button icon={<UploadOutlined />}>Select a file</Button>
                        </Upload>
                    </Form.Item> */}

<Col xs={24} sm={24} md={24} lg={24} xl={24} >
                        <Form.Item>
                            <div className="mt10" style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
                                <Button
                                    onClick={onBack}
                                    icon={<LeftOutlined />}
                                >
                                    Go Back
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                >
                                    Save And Proceed <RightOutlined />
                                </Button>
                            </div>
                        </Form.Item>
                        </Col>
                        </Row>
                    </Form>
                </div>
                </div>
            </LeftLayout>
        </Spin>
    );
};

export default CapitalProviderProfessionalDetails;